import axios from 'axios'
import config from '../apiConfig'
import url from '../baseUrl'
let baseUrl = url.baseUrl
let serEqbaseUrl = url.serEqbaseUrl
//文件存储

const $ajaxAddFile = params => axios.post(baseUrl + '/storage/addFile', params)

//保姆安心包上传文件
const $ajaxSerEqbaseUrlAddFile = params => axios.post(serEqbaseUrl + '/storage/addFile', params);


const linkFileUrl = baseUrl + "/storage/getFile?fileId=";

const reqFile = function (fileId) {
    return linkFileUrl + fileId;
}

const addFile = baseUrl + "/storage/addFile?createAccount=";



export default {
    $ajaxAddFile,
    linkFileUrl,
    reqFile,
    addFile,
    $ajaxSerEqbaseUrlAddFile
}